module.exports = __webpack_public_path__ + "static/call_sheet_page@3x-c5c43436af4850cedc2e5733cad755a6.png";